// This file should be temporary
// It is used to limit compare to the below categories on mobile devices

import React, { useState, useEffect } from 'react';

const data = [
  'bdc4638d-bc06-483e-ae43-f547a010dec4', // Carpet Cleaners
  '9d0073c6-34b9-45eb-b68e-b94f0d734ff3', // Canister Vacuums
  'bcaca49f-5d90-4bce-bef0-29fbfd89ec35', // Central Vacuums
  'f9fa833a-8327-41c7-889a-b7f25833ada1', // Handheld Vacuums
  '4103a040-3981-448f-9535-97962e27a626', // Robot Vacuums
  'e6064c06-d003-45e0-b84d-c01164ee21ce', // Stick Vacuums
  '987d9116-942f-4c20-9650-b75ce092a42a', // Upright Vacuums
  '741c53ed-0643-4b64-87e4-cb9213ae64e6', // Backpack Vacuums
  '58bf26c6-54a5-4b30-960c-ba9994a66011', // Sweepers
  '0f33345e-85f8-44e9-aa5c-a030fc4f8822', // Steam Mops
  '6697ae26-f757-4828-9200-583bf3088465', // Floor Scrubbers & Buffers
  'd902e346-2320-4ad8-b5ae-fd452c85145b', // Electric Cooktops
  'bc33f7d7-da42-4441-94d8-d28b4870d6c2', // Gas Cooktops
  'c5bf55e4-fe6f-4aa2-ab9d-2bc46fa6c111', // Induction Cooktops
  'ab375db2-b605-4bcb-931a-d14344586d6e', // Over-the-Range Microwaves
  'fdd15fa2-6058-4963-bbe5-9f8df00801f7', // Built-In Microwaves
  'a55383c0-4e62-44cf-8cf3-fd389bc330e1', // Countertop Microwaves
  'a094d6df-8ad7-441d-b379-c8effced4ba1', // Microwave Drawers
  '73761407-640a-42fd-b424-f2ccd67ec5eb', // Downdraft Range Hood
  '1e7e9c62-ef94-4c9b-9b6d-177711fe37f3', // Island Range Hoods
  '4aa42663-477a-4ff5-95d8-615431f6f4c0', // Under Cabinet Range Hoods
  '48bd3829-3848-4b20-bae3-4b83ae0ab57e', // Wall Mount Range Hoods
  '424619ff-90aa-4608-9014-86f92d33e9d3', // Double Oven Electric Ranges
  'a03bb926-daf8-470d-a7d9-8475bf62d1ac', // Single Oven Electric Ranges
  '0e376a3b-4794-482f-a3c0-b57e6c0397d0', // Double Oven Gas Ranges
  'dfd09431-6ecb-46a4-a920-d2d8424db86c', // Single Oven Gas Ranges
  '103aa240-8a27-481f-9af7-1b919c0780f5', // Double Oven Dual Fuel Ranges
  '2ffafb80-f55f-48be-b192-ce5399d20a2a', // Single Oven Dual Fuel Ranges
  '89992582-781e-4516-aeaf-067a92f785cb', // Double Electric Wall Ovens
  'cd08ca2d-d435-4ec2-9a27-2baf0efafb7a', // Single Electric Wall Ovens
  'adb303c2-2a72-40fa-a8aa-b3a6aa35c801', // Single Gas Wall Ovens
  '888cbd40-9d3c-4c6e-9024-04d452ecf888', // Wall Oven & Microwave Combinations
  '407659be-7b81-4efe-9e3d-ad7cd9c9de7d', // Warming Drawers
  'a0cdda6b-3c98-40ca-8690-92910f5dfbe3', // Bottom Freezer Refrigerators
  'aa86d425-3f8a-48b7-a788-4a086005b9f4', // Freezerless Refrigerators
  '77453ad6-a06a-47ee-8d87-1c8dd632e12d', // French Door Refrigerators
  'f93d5540-c927-4159-badc-f592fb24a9d0', // Side by Side Refrigerators
  '1aba46ba-ce01-478a-a88e-bb0b65f6de5b', // Top Freezer Refrigerators
  '45bdd04c-b130-4a5a-a07b-7307cd3d39dd', // Commercial Refrigerators
  'c0f31509-1de2-4732-a3a2-26fc53a7a18d', // Drawer Refrigerators
  '01e62ab7-d37e-4c42-8bb6-d83827119c3b', // Built-In Dishwashers
  '92740d7e-536a-486a-bd75-eae716c41a2d', // Portable Dishwashers
  '5180bfc5-d590-481c-a994-d37bc7cabcba', // Countertop Dishwashers
  '17294b29-512b-4fb1-9865-73e090909936', // Garbage Disposals
  '1961473e-a0a4-4948-a2bc-410904f1a90e', // Chest Freezers
  '2dda52e1-0f0e-4eaf-be10-3aafaf329c7b', // Built-In & Freestanding Ice Makers
  'f5fa5daf-1f02-4f3b-a8a7-870fd491fd57', // Portable Ice Makers
  '88ea22b0-18cc-4d46-91f6-e190422f997b', // Commercial Ice Makers
  '812e8b73-2b7a-4acd-9d8d-24599d3a1a72', // Portable Freezers
  '9137c760-6595-4687-9014-e7b702efb8c2', // Upright Freezers
  'dc22d255-5b4b-4731-a947-1e5463e0ab79', // Commercial Freezers
  '25a0baa5-cd17-4c04-ac40-8ad3e424c892', // Kegerators
  '4ac2849f-edd9-4f94-9ef5-a38eb771fe8d', // Wine Cellar Cooling Units
  'bd19eb23-e8e6-421f-82cb-7af127d5fec8', // Wine Preservers
  'bde25aff-251a-419c-82cd-37898c563e60', // Wine Coolers
  'a761e88c-3071-4c3e-8472-5bcd8910c10c', // Beverage Refrigerators
  '008fea22-0b5e-4d30-a9b7-549212945022', // Beverage & Wine Combos
  'c356f747-df45-4658-b62c-1716a949ef1c', // Front Load Washers
  '420c6835-6f62-45f8-b305-99db00e54a0e', // Top Load Washers
  '9dd49c7d-3a90-4824-b5b0-f3c6e888479b', // Portable Washers
  '88bb5899-15c6-4207-9fe9-892b5cfb9d2b', // Washer Dryer Combos
  'f9445e9f-0ee2-4056-bc36-31b9922678df', // Electric Dryers
  '30a26b27-6ac0-4cc1-8160-3faa1643aab5', // Gas Dryers
  '8acc53ee-5d5d-4d4a-b31d-6f67e7b80ea4', // Laundry Centers
  'ea464276-4324-493f-aa6f-764ef11ff935', // Mini Fridges
  '62b1c4e3-a66c-43b4-a1c4-b86cc9181621', // Trash Compactors
  'e6b6a873-e70c-4497-9261-7b0ab00c87b4', // Augers
  '5e4be180-5ec9-4ad4-9254-c73a45a08d6f', // Gas Chainsaws
  'c075edba-47f8-415e-8ba0-3c0fe1e0a7bf', // Chainsaw Bars
  '6fa08b57-bf24-4b91-a508-3ba05640f348', // Chainsaw Chains
  '0ba2d632-b855-4ebf-9638-ffe6b181f28e', // Chainsaw Bar & Chain Combo
  '0233196e-db32-42ae-9e39-7009323ac837', // Cordless Pole Saws
  '1b985f7c-3c72-45d4-8c14-997d268d54b5', // Electric Pole Saws
  '015ca2c0-9c44-4b03-b216-de9307fe151e', // Gas Pole Saws
  '696a2ed5-1518-4825-9523-f57c86bff99d', // Cordless Chainsaws
  '38dd38dc-79f7-4225-b649-27d43403e317', // Electric Chainsaws
  '182a273f-4c3a-4f12-bc96-b45fcd60ab8f', // Chainsaw Files
  '02170814-88e3-4bed-a03b-c4dd5e31bd0d', // Electric Chainsaw Sharpeners
  '12cb990d-5058-422d-adcf-20a76757400c', // Chainsaw Sharpening Tools
  '3fa5df39-36d0-4385-86f5-3b6e012daac0', // Electric Log Splitters
  'adc65a19-4466-43eb-b615-111244c94b4a', // Gas Log Splitters
  '3c2dea34-ed41-4952-9289-737d44fbb7db', // Manual Log Splitters
  '76907ef1-3c36-4c65-955c-772e80fd5161', // Log Splitter Accessories
  'ab454838-0f13-4bcd-a599-beb85ff4f95d', // Accessories
  '413acb85-2a5f-4009-a777-505f3ad9aead', // Portable Generators
  '45bab351-1c25-4724-91b4-a9e08a9d7fb3', // Standby Generators
  '65fbca22-cbdb-44db-bdac-781733c7322b', // Cordless Leaf Blowers
  'dcd914e0-83ea-48df-920f-a72fcae8d2ae', // Electric Leaf Blowers
  '9b0f2e6a-55e7-4452-9c5a-99844f230429', // Gas Leaf Blowers
  'ed99da4f-d546-4d3d-bacb-e7869879016c', // Pressure Washers
  '26ffe643-e80d-43e6-9745-5d088eb793e0', // Hoses
  '61f63b19-2e92-463a-84d4-b9e6c50289f2', // Pumps
  '50c17fdb-e7c6-4fd8-a356-270547b6efde', // Nozzles
  'a2b5e03a-ccc4-402e-9c42-3176b327a373', // Wands
  'b949bd97-cb8a-4046-81cf-8d8dfb3701c2', // Guns
  '3f2b7ea3-ca7a-4169-b287-222f4d1dc2bd', // Accessories
  '113b7345-4706-4bcf-9dd4-bc6fe276fa59', // Electric Wood Chippers
  '228b3ae7-f401-4533-afd5-0535091b4d48', // Gas Wood Chippers
  'df2b65d2-ac79-4dfe-a21c-cbe5d6b26f59', // Outdoor Power Batteries & Chargers
  '4c9881d0-4b32-4abb-870a-65213e6e4085', // Belts
  'ee206df7-08c3-4033-a742-1f04b5788fda', // Replacement Engines
  'bea9d4bc-574f-4acd-ab1c-3cbd588b3dda', // Miscellaneous Parts
  'aaf2db99-c132-4db0-82c9-a7f7d8bb62f2', // Lawn Mower Spark Plugs
  '26390971-8227-4d0e-a4cd-34f3e5e9fbd9', // Replacement Wheels
  'f4831995-9b4b-4a87-87cd-e6ec71fcf6c0', // Replacement Tires
  '9b5aeef8-8deb-4a63-bb79-3da8290a8f1f', // Replacement Engine Parts
  'c2db2ddf-6ed1-4b2d-9545-5c139ca45662', // Lawn Mower Blades
  '21fe2bcb-c0e0-4b31-aa46-61dba16aad88', // Lawn Mower Filters
  'c5722191-3803-4c2d-a097-f6baee2a56fe', // Gas Cans
  '7744f2fd-fca4-4e00-8d18-f9e7093509ba', // Oils, Lubricants & Additives
  'c817bd77-e33b-40ce-88e4-9a21c682d4d1', // Tune-up Kits
  '4876a44a-697f-457f-be16-a47fc6e5ad63', // Blade Sharpening Tools
  'f4dbe126-f85c-4cd5-adcd-d7cc9d8f6dff', // Lawn Mower Bags
  '1ea19ea0-7c9e-4a64-ad0f-bb0d6b0b2b1b', // Core Aerators
  '901db3db-a19d-49e3-934d-b5dadc3a0be2', // Dethatchers
  'e11064f4-fec6-4bc1-bd6b-3da0bfaa70b5', // Dump Carts
  '37287aa8-99b7-4e9b-ae11-8dd640ac9737', // Lawn Sweepers
  '9e8bda25-7241-46bb-9ee5-d7040bebc991', // Lawn Mower Lifts
  '86509781-bf9f-41b8-8e3d-1e0dd71bc93f', // Pull-Behind Mowers
  '9624cc7a-e6f1-4e5e-9054-67fd77bca502', // Other Mower Attachments
  '7c5a5834-6fee-4054-89a3-0217731f8ed9', // Lawn Mower Rollers
  'c87469dd-3442-4d19-9732-e3d3c216294f', // Lawn Mower Sprayers
  '4dccaedd-e259-462a-8e42-a478e363e763', // Pull Behind Spreaders
  'e930f3c5-2449-499f-b3f9-dee5959515e6', // Tillers
  'b0cc723f-cb79-4640-a7df-646ec460894c', // Box Scrapers
  'c3179942-5a68-49f4-96b6-9002ea8ffde5', // Lawn Mower Snow Plows
  '6f95d769-f096-4422-ad2f-96e42399d231', // Lawn Mower Covers
  '14a8d2d4-f1ac-4814-a3e2-edf10c94f541', // Lawn Striping & Mulching
  '09964ef2-1c3b-4503-a05b-87764f876373', // Lawn Mower Vacuums
  '9b2e673b-98c8-4c17-8c46-4c2e4d39d03c', // Lawn Mower Ramps
  'bd366893-e7f6-4f45-9ccf-a668bc9dda3a', // Lawn Mower Cultivators
  'aff6cfe1-a794-41c5-a6a6-cbe90a1d9f30', // Cordless Snow Blowers
  '5d137773-ee79-4abb-9037-0961a2f646e9', // Electric Snow Blowers
  '8082628a-8da3-4614-a394-dab10c2afff5', // Gas Snow Blowers
  'c9d3a52f-46ef-4810-88db-cd40d7415016', // Snow Plow Parts
  'd47d2f95-0a40-4fa3-a74c-9f1cba7614c0', // Snow Blower Parts
  '9ec682a0-734a-45d0-8608-f25dcc0323d2', // Snow Plows
  '3b366ef8-4b8b-4e90-ae32-37fcbf0f9ab4', // Salt Spreaders
  '8419f271-d2ff-4962-bac3-aecc43aa66da', // Ice Melt
  '022d10ab-f7f2-4ac5-93e8-a11ef56ed690', // Traction Control
  '7cc49755-42d2-4d81-98e6-19cde897478b', // Snow Plow Mounts
  'e58d5e61-9bf4-4dd0-9610-939713866ac9', // Tillers
  '8285f7a6-3922-4085-a32f-9910ffd73afd', // Cultivators
  '68514fd2-10c1-47f3-8f2d-ef505394a527', // Tiller Parts
  '8d624db9-d727-483b-b094-bddaa98598fd', // Brush Cutters
  '2eab6fc9-dda2-426a-8f5f-6fd4d8d62b7d', // Gas Edgers
  'fbd2888e-c082-4332-ab68-fcd1bbbc58a2', // Cordless Edgers
  '4908d053-4912-4e1e-b8df-c6c26fc7c592', // Electric Edgers
  '18042469-07d8-4894-8be4-47995b43e348', // Cordless Hedge Trimmers
  'f9779380-13a9-4ab6-9c4b-99fd092cf7e1', // Electric Hedge Trimmers
  '1b9a0b55-cf63-4ea1-b8d8-72cc409b2ac1', // Gas Hedge Trimmers
  '3fbffaa4-fba2-421d-ad35-43920760a152', // Cordless String Trimmers
  '7651c252-aec3-4d90-88e2-6f4fe31d6a1d', // Gas String Trimmers
  'fcb0baaf-4918-4eb5-b3d1-c79564a8281f', // Electric String Trimmers
  '42d0cc6f-6fe8-43e3-828b-f30fc13ad0bf', // Trimmer Attachments
  'c1ca1a7f-783d-4b99-8955-281cc23deb45', // String Trimmer Heads
  '7ebe912c-dd1a-4963-8cb8-57edadcdfb36', // String Trimmer Line
  'cfa3cf58-8d62-47af-8987-7b75901aeea0', // Stump Grinders
  '3471aedc-3ce3-4a05-ba69-fa01e2d51f66', // Plate Compactors
  '9ef0153e-d69e-4715-a537-04134ec5f76f', // Field Mowers
  '10fbaf88-7b5b-4e58-a30a-85331cb2bc9d', // Push Lawn Mowers
  'dfe37bca-2158-4ecb-b27c-d7959116ed7f', // Reel Lawn Mowers
  'c0031913-cc2e-4ff4-afb7-3aa61129b726', // Robotic Lawn Mowers
  '9c942cfa-18f8-4358-8922-b927deba05d7', // Self Propelled Lawn Mowers
  'ea06de7d-9f29-4512-ad0b-b0cad844ce2b', // Commercial Lawn Mowers
  '51bf0da5-292a-43b5-b472-251b0c7230c4', // Zero Turn Mowers
  'b68fe0b1-10ee-48c4-b539-0a4decf1c377', // Lawn Tractors
  '0d47bec6-1902-4ab4-8cef-fcf9742fe409', // Garden Tractors
  '0de42969-3c0d-4085-8ed6-d683c6546671', // Rear Engine Riding Mowers
  '67583e53-e849-49e6-97e2-d787cfa83aa6', // Outdoor Power Combo Kits
  '67463edd-8326-436b-b6c2-f1d95f3d6e34', // Wood Mulch
  'e59a27e8-9cec-43d4-87d4-58f2a16a4b4d', // Rubber Mulch
  '368333b0-32c0-4627-a188-b7e9675f8cf3', // Landscape Accessories
  'b7cd0bfe-ed2d-4dac-9e7f-b763487c882a', // Topsoil
  'd1af1cd7-be24-40bf-8b58-219ba9d26fc2', // Potting Soil
  '418348e1-0231-4da5-a55d-abc1dbaa1b3d', // Garden Soil
  '9a0f759e-99af-4312-889c-6005c5c13d83', // Raised Bed Soil
  '1c86f6be-e475-4580-9ed0-81de4fd2d6d1', // Landscape Fabric
  'fb081ff0-4984-494b-9811-04ca8b4cbe70', // Sod & Turf
  '126ba083-2a3b-47a1-910e-1e765a80c524', // Plastic Edging
  'ba9809e4-c66e-46e2-a8be-6128d93dc65f', // Edging Stones
  '47177398-68ce-4275-935f-f17323344319', // Brick Edging
  '6cd14d22-83e7-42d0-89c2-1dc8e4f3fed6', // Metal Edging
  '0161ce0f-1507-4e84-bc26-68c3180cad24', // Rubber Edging
  'e4cf140f-06a4-42ff-989b-0baf74a27381', // Concrete Edging
  '6ae320cf-44e5-427b-8b18-1157cee663a4', // Wood Edging
  '18df4d50-3637-4133-acaf-5e3c193eac1c', // Retaining Wall Blocks
  '8aa8c48e-102e-4adf-beef-bc6b3d8e048c', // Garden Wall Blocks
  '8eaccf5b-7f88-4f35-8ed1-fd54362d792e', // Bagged
  '7de483a8-36d3-4b0c-b8b3-703122a5e2e8', // Bulk
  'c6dae0cb-1f2f-419a-b3ad-20b536b2e3f2', // Concrete Pavers
  '38dee308-60cc-4a77-a31e-f6e947ccaa5b', // Stone Pavers
  'a94c7c93-a458-4283-9ca6-b0c2a3eaa6e3', // Travertine Pavers
  'af91d588-f4f9-41c4-afac-50f7b4b70414', // Rubber Pavers
  'ecbcc83d-8393-48b5-b17f-2fab2ccfa523', // Plastic Pavers
  'b80fea6b-651f-4e56-8aba-8a558501508f', // Brick Pavers
  'f46a6009-d1b7-4ee0-9ab2-d943f5e04a2d', // Porcelain Pavers
  '7fa7faf4-69be-49d5-a16c-059ec967858c', // Outdoor Living Kits
  '788de869-ebf5-4438-a416-37888ce0ffd5', // Stepping Stones
  '6da26eb3-26fb-4106-883d-6cbdb498380a', // Barrel Grills
  '1e322cc9-06d8-4d3c-8253-0453637dddc1', // Cart-Style Grills
  '385b6868-08e9-4ac0-a00c-ec65c7114742', // Kamado Grills
  '5ef40100-0139-4f69-afb0-d3ba277a21ea', // Kettle Grills
  '5e01283f-fe2b-4e6e-bfd6-337c18b011da', // Electric Smokers
  'aec6e52b-c423-46b6-b9df-da745a731054', // Charcoal Smokers
  '3f2fccf0-584d-416e-90b5-028c8f3d6fe8', // Propane Smokers
  'dc530de2-2ba2-4db9-81e9-3d670d83326a', // Electric Grills
  '6ad0c2da-f9dc-400a-a942-6dfd716fcd2b', // Portable Charcoal Grill
  '66888c58-f291-4da4-b11e-59bf40f53dee', // Portable Propane Grill
  '1de27e33-4cfe-427d-8347-df72daf0e075', // Propane Grills
  'cf63fd8b-8af0-4385-8666-bddcffcbd9c9', // Natural Gas Grills
  'a1adb60b-5298-4f73-b967-41487612188a', // Gas & Charcoal Combo Grills
  '78b2ebb1-a5da-4255-a86b-27b1570c4e1c', // Flat Top Grills
];

const useComparableCategory = ({ categoryID }) => {
  const [isComparable, setComparable] = useState(false);

  useEffect(() => {
    setComparable(data.includes(categoryID));
  }, [categoryID]);

  return isComparable;
};

export { useComparableCategory };